import { useEffect } from "react";

import { ensureElectronSalesSession, queryClient } from "@api/clients";
import { useUiStore } from "@stores/uiStore";
import { useUserStore } from "@stores/userStore";

/** Silent Electron bridge; this hook has no effect in a browser. */
export function useElectronSalesSync() {
  useEffect(() => {
    const desktopApi = globalThis.window?.api;

    if (!globalThis.window?.env?.isElectron || !desktopApi?.setSalesSession)
      return;
    const update = () => {
      ensureElectronSalesSession().catch(() => {});
    };

    update();
    const unsubscribeUser = useUserStore.subscribe(update);
    const unsubscribeLocale = useUiStore.subscribe(update);
    let debounce: ReturnType<typeof setTimeout>;
    const unsubscribeChanges = desktopApi.onSalesDataChanged(() => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        queryClient
          .invalidateQueries({
            predicate: (query) =>
              /salesInvoices|salesInvoiceReturns|productBatches|customers|warehouses/.test(
                JSON.stringify(query.queryKey),
              ),
            refetchType: "active",
          })
          .catch(() => {});
      }, 250);
    });

    return () => {
      clearTimeout(debounce);
      unsubscribeUser();
      unsubscribeLocale();
      unsubscribeChanges();
    };
  }, []);
}
